module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-34-4a619b2977241cbd174ae877f8148e8f.svg";